export default __webpack_public_path__ + "static/media/CallOut.35da9acd.svg";